import {
  getPendingStopStatusWithDelayDuration,
  getMinutesInHourAndMinutesStr,
} from "../../util";
import PickupDeliveryPopupRenderer from "./PickupDeliveryPopupRenderer";
import constants from "./constants";
const PendingStopDelayedPopup = ({ task , enableRevisitDeliveryStop=false}) => {
  const { totalTime } = getPendingStopStatusWithDelayDuration(
    task.data,
    task.dispatchDate
  );
  return (
    <PickupDeliveryPopupRenderer
      stopType={task?.data?.stopType}
      arrivalTimeLabel={constants.POPUP_LABELS.EST_ARRIVAL_TIME}
      arrivalTime={task.arrivalTime}
      departureTimeLabel={constants.POPUP_LABELS.EST_DEPARTURE_TIME}
      departureTime={task.departureTime}
      stopTime={getMinutesInHourAndMinutesStr(task.stopDuration)}
      stopTimeLabel={constants.POPUP_LABELS.EST_STOP_TIME}
      statusLabel={constants.POPUP_LABELS.LATE_ARRIVAL}
      statusValue={totalTime ? totalTime : ""}
      stopStatusClass="violation"
      serviceWindow={task?.data}
      stopData={task.data}
      enableRevisitDeliveryStop={enableRevisitDeliveryStop}
    />
  );
};

export default PendingStopDelayedPopup;
